export default () => {
  const el = document.querySelector('[data-hero-nav-cover]');

  if (el) {
    const nav = document.querySelector('[data-page-header]');
    const classes = {
      hasHero: 'page-header--hero',
    };

    const addCorrectClass = () => {
      if (window.scrollY > 100) {
        nav.classList.remove(classes.hasHero);
      } else {
        nav.classList.add(classes.hasHero);
      }
    };

    nav.classList.add(classes.hasHero);

    window.addEventListener('scroll', addCorrectClass);
  }
};
